import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { ProductFiltersButton } from '../../../components/product/product-filters-button/product-filters-button';
import {
  ProductFilters,
  ProductFiltersPanel,
} from '../../../components/product/product-filters-panel/product-filters-panel';
import { ProductList } from '../../../components/product/product-list/product-list';
import { ProductNewArrivalDescriptions } from '../../../components/product/product-new-arrival-descriptions/product-new-arrival-descriptions';
import { ProductOrderBySelect } from '../../../components/product/product-order-by-select/product-order-by-select';
import { RecentlyViewedProductList } from '../../../components/product/recently-viewed-product-list/recently-viewed-product-list';
import { SlideRightDirective } from '../../../directives/animations/slide-right.directive';
import {
  Product,
  ProductCollection,
  ProductCollections,
} from '../../../models/product';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import {
  ProductApiService,
  ProductOrderBy,
} from '../../../services/apis/product-api.service';
import { ApiException, ApiStatus } from '../../../services/apis/status';
import { MessageService } from '../../../services/message.service';
import { TitleService } from '../../../services/title.service';
import { mergeRouter } from '../../../utils/router';
@Component({
  selector: 'app-product-collection-page',
  imports: [
    FileurlPipe,
    NgOptimizedImage,
    RouterModule,
    MatProgressSpinnerModule,
    ProductFiltersPanel,
    FormsModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    ProductOrderBySelect,
    ProductNewArrivalDescriptions,
    ProductFiltersButton,
    RecentlyViewedProductList,
    NzEmptyModule,
    ProductList,
    SlideRightDirective,
  ],
  templateUrl: './product-collection-page.html',
  styleUrl: './product-collection-page.scss',
})
export class ProductCollectionPage implements OnInit {
  filters: ProductFilters = {
    sizes: [],
    color: '',
    category_ids: [],
  };
  collection?: ProductCollection;
  collectionLoading: boolean = false;
  productsLoading: boolean = false;
  page: number = 1;
  pageSize: number = 24;
  total: number = 0;
  products: Product[] = [];
  orderBy: ProductOrderBy = ProductOrderBy.RECOMMENDED;
  constructor(
    private titleService: TitleService,
    private productApi: ProductApiService,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.filters.sizes = params.getAll('sizes');
      this.filters.color = params.get('color') ?? '';
      this.filters.category_ids = params
        .getAll('category_ids')
        .map((v) => parseInt(v));
      this.page = parseInt(params.get('page') ?? '1');
      this.orderBy =
        (params.get('order_by') as ProductOrderBy) ??
        ProductOrderBy.RECOMMENDED;
      this.findProductCollectionProducts();
    });
    this.route.paramMap.subscribe((params) => {
      const no = params.get('no') ?? '';
      this.page = 1;
      this.getProductCollection(no);
    });
  }

  get isNewArrivals(): boolean {
    return this.collection?.no === ProductCollections.NewArrivals;
  }

  onFiltersChanged() {
    this.page = 1;
    mergeRouter(this.router, this.route, {
      sizes: this.filters.sizes,
      color: this.filters.color,
      category_ids: this.filters.category_ids,
      page: this.page,
    });
    // this.findProductCollectionProducts();
  }

  onOrderByChanged() {
    this.page = 1;
    mergeRouter(this.router, this.route, {
      order_by: this.orderBy,
      page: this.page,
    });
    // this.findProductCollectionProducts();
  }

  async getProductCollection(no: string) {
    try {
      this.collectionLoading = true;
      this.collection = await this.productApi.getProductCollection(no);
      this.titleService.setTitle(this.collection.name);
    } catch (error) {
      if (error instanceof ApiException) {
        if (error.status === ApiStatus.PRODUCT_COLLECTION_NOT_FOUND) {
          this.messageService.open('Collection not found', 'OK');
        }
      }
    } finally {
      this.collectionLoading = false;
      this.findProductCollectionProducts();
    }
  }
  async findProductCollectionProducts() {
    if (!this.collection) {
      return;
    }
    try {
      this.productsLoading = true;
      const r = await this.productApi.findProductCollectionProducts(
        this.collection.no,
        {
          page: this.page,
          page_size: this.pageSize,
          color: this.filters.color,
          sizes: this.filters.sizes,
          category_ids: this.filters.category_ids,
          order_by: this.orderBy,
        }
      );
      this.products = r.items;
      this.total = r.total;
      this.page = r.page;
      this.pageSize = r.page_size;
    } catch (error) {
    } finally {
      this.productsLoading = false;
    }
  }

  onPageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1;
    mergeRouter(this.router, this.route, {
      page: this.page,
    });
    // this.findProductCollectionProducts();
  }
}
